import React, { useCallback, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import { useAlert, useInput, useUserInfo } from '../../../../hooks';
import { pwdChangeAPI } from '../../../../api/accountAPI';
import { TYPE } from '../../../../constant';
import useAmplitude from '../../../../hooks/useAmplitude';

function PwForm({
  pwLength = 8
}) {
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const [Alert] = useAlert();
  const [onOffChange, setOnOffChange] = useState(false);
  const [
    nowPwdCheck,
    // setNowPwdCheck
  ] = useState(false);
  /**
   * length: 8자 이하,
   * diff: 두 비밀번호가 다를 때
   */
  const [newPwCheck, setNewPwCheck] = useState("");
  const [nowPwd, setNowPwd, nowPwdReset] = useInput('');
  const [newPwd, setNewPwd, newPwdReset] = useInput('');
  const [newRePwd, setNewRePwd, newReReset] = useInput('');

  const [pwView, setPwView] = useState({
    "pw1": false,
    "pw2": false,
    "pw3": false,
  })
  
  const handleOnoff = useCallback(() => {
    nowPwdReset("");
    newPwdReset("");
    newReReset("");
    setNewPwCheck("");
    setOnOffChange(!onOffChange);
  }, [onOffChange]);

  const handlePwViewChange = (name) => {
    setPwView((old) => ({
      ...old,
      [name]: !old[name]
    }))
  }

  const onBlur = (e) => {
    const name = e.target.name;
    if (_.isEqual(name, 'newPwd') || _.isEqual(name, 'newRePwd')) {

      if (newPwd.length < pwLength) {
        setNewPwCheck('length');
        return;
      } else if (!_.isEqual(newPwd, newRePwd)) {
        setNewPwCheck('diff');
        return;
      }
    }

    setNewPwCheck('');
  }

  const onSubmit = useCallback(async () => {
    const { userId, channelCode } = info;
    const resp = await pwdChangeAPI({
      sbsceMbrId: userId,
      chnCd: channelCode,
      mbrId: userId,
      pw: nowPwd,
      newPw: newPwd
    });

    if (_.isEqual(resp?.code, 'S000000')) {
      handleOnoff();
      setAmplitudeLog({ eventCategory: 'account', eventName: '회원 정보변경' });
      Alert(t("MY_03_01.msg035"));
    }
  }, [nowPwd, newPwd, newRePwd, newPwCheck]);

  const setScroll = useCallback(() => {
    const dom = document.getElementById("input_title");
    if (!dom) return;

    dom.scrollIntoView(true);
  }, [])

  return (
    <div className="item cls">
      <div className="input_title" id="input_title">{t("MY_03_01.msg003")}</div>
      
      {
        !onOffChange
          ? (
            <div className="input_cont">
              <div className="click_line">
                <button
                  type="button"
                  className="mint_txt_btn"
                  onClick={handleOnoff}
                  // disabled
                >
                  {t("MY_03_01-GM.msg003")}
                </button>
              </div>
            </div>
          )
          : (
            <div className="input_cont h56 pw">
              <ul>
                <li>
                  <div className="input_box white_box">
                    <input
                      type={pwView.pw1 ? 'text' : 'password'}
                      placeholder={t("MY_03_01-GM.msg012")}
                      value={nowPwd}
                      onChange={setNowPwd}
                      onClick={setScroll}
                    />
                    <div className="r_area">
                      {
                        info.channelCode === TYPE.CHANNEL.GLOBAL01 && (
                          <button type="button" onClick={() => handlePwViewChange("pw1")}>
                            {
                              pwView.pw1
                                ? <img src="./static/images/icon/btn_join_eye_on.svg" alt="" />
                                : <img src="./static/images/icon/btn_join_eye_off.svg" alt="" />
                            }
                          </button>

                        )
                      }
                      <button type="button" onClick={nowPwdReset}>
                        {(!nowPwdCheck && nowPwd.length > 0) && (
                          <img src="./static/images/icon/input_delete_40.svg" alt="" />
                        )}
                        {
                          nowPwdCheck && (
                            <img src="./static/images/icon/ic_error.svg" alt="" />
                          )
                        }
                      </button>
                    </div>
                  </div>
                  {
                    nowPwdCheck && (<div className="info_txt red">{t("MY_03_01-GM.msg013")}</div>)
                  }
                  
                </li>
                <li>
                  <div className="input_box white_box">
                    <input
                      type={pwView.pw2 ? 'text' : 'password'}
                      name="newPwd"
                      placeholder={t("MY_03_01-GM.msg014", { c: pwLength })}
                      value={newPwd}
                      onChange={setNewPwd}
                      onBlur={onBlur}
                      onClick={setScroll}
                    />
                    <div className="r_area">
                      {/* <img src="./static/images/icon/ic_check.svg" alt="" /> */}
                      {
                        info.channelCode === TYPE.CHANNEL.GLOBAL01 && (
                          <button type="button" onClick={() => handlePwViewChange("pw2")}>
                            {
                              pwView.pw2
                                ? <img src="./static/images/icon/btn_join_eye_on.svg" alt="" />
                                : <img src="./static/images/icon/btn_join_eye_off.svg" alt="" />
                            }
                          </button>

                        )
                      }
                      <button type="button" onClick={newPwdReset}>
                        {
                          (!_.isEqual(newPwCheck, 'length') && !_.isEmpty(newPwd)) && (
                            <img src="./static/images/icon/input_delete_40.svg" alt="" />
                          )
                        }
                        {
                          (_.isEqual(newPwCheck, 'length') && !_.isEmpty(newPwd)) && (
                            <img src="./static/images/icon/ic_error.svg" alt="" />
                          )
                        }
                          
                      </button>
                    </div>
                  </div>
                  {
                    (_.isEqual(newPwCheck, 'length') && !_.isEmpty(newPwd)) && (
                      <div className="info_txt red">
                        {t("MY_03_01-GM.msg015", { c: pwLength })}
                      </div>
                    )
                  }
                </li>
                <li>
                  <div className="input_box white_box">
                    <input
                      type={pwView.pw3 ? 'text' : 'password'}
                      name="newRePwd"
                      placeholder={t("MY_03_01-GM.msg016")}
                      value={newRePwd}
                      onChange={setNewRePwd}
                      onBlur={onBlur}
                      onClick={setScroll}
                    />
                    <div className="r_area">
                      {/* <img src="./static/images/icon/ic_check.svg" alt="" /> */}
                      {
                        info.channelCode === TYPE.CHANNEL.GLOBAL01 && (
                          <button type="button" onClick={() => handlePwViewChange("pw3")}>
                            {
                              pwView.pw3
                                ? <img src="./static/images/icon/btn_join_eye_on.svg" alt="" />
                                : <img src="./static/images/icon/btn_join_eye_off.svg" alt="" />
                            }
                          </button>

                        )
                      }
                      <button
                        type="button"
                        onClick={newReReset}
                      >
                        {
                          (!_.isEqual(newPwCheck, 'diff') && !_.isEmpty(newRePwd)) && (
                            <img src="./static/images/icon/input_delete_40.svg" alt="" />
                          )
                        }
                        {
                          (_.isEqual(newPwCheck, 'diff') && !_.isEmpty(newRePwd)) && (
                            <img src="./static/images/icon/ic_error.svg" alt="" />
                          )
                        }
                      </button>
                    </div>
                  </div>
                  {
                    (_.isEqual(newPwCheck, 'diff') && !_.isEmpty(newRePwd)) && (
                      <div className="info_txt red">
                        {t("MY_03_01-GM.msg017")}
                      </div>
                    )
                  }
                </li>
              </ul>
              <div className="btns cls">
                <div className="left">
                  <button
                    type="button"
                    className="btn-small btn-gray"
                    onClick={handleOnoff}
                  >
                    {t("MY_03_01.msg022")}
                  </button>
                </div>
                <div className="right">
                  <button
                    disabled={
                      _.isEmpty(nowPwd)
                      || _.isEmpty(newPwd)
                      || _.isEmpty(newRePwd)
                      || !_.isEqual(newPwd, newRePwd)
                      || newPwd.length < pwLength
                    }
                    className="btn btn-blue"
                    onClick={onSubmit}
                  >
                    {t("MY_03_01-GM.msg018")}
                  </button>
                </div>
              </div>
            </div>
          )
      }
    </div>
  );
}

export default PwForm;